import React, {useState, useEffect} from 'react'

const MyQuery = ({ userDetails }) => {
  const [complaints, setComplaints] = useState([]);
  const [error, setError] = useState(null);

  const userId = userDetails.id;

  useEffect(() => {
    if (userId) {
      // Fetch complaint history from the backend API using fetch
      fetch(`https://api.dectwincam.com/api/get-complaints?userId=${userId}`)
      .then(async response => {
        // Log the response to check what is being returned
        const text = await response.text();
        console.log('Response Text:', text);  // Log the raw response for debugging
    
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}, response: ${text}`);
        }
    
        // Attempt to parse JSON
        return JSON.parse(text);
      })
      .then(data => {
        setComplaints(data.tickets || []);
      })
      .catch(error => {
        console.error('Error fetching complaints:', error);
        setError('Failed to fetch complaints');
      });    
    } else {
      setError('No user ID found');
    }
  }, [userId]);  // Depend on userId to fetch complaints when it changes

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB'); // For format "DD/MM/YYYY"
  };


  return (
    <>
    <section className='py-5 bg-light'>
      <div className='container'>

      <div className="d-flex justify-content-center">
            <hr className="shop-hr" />
            <h4 className="px-3 text-center text-nowrap">Complaints History</h4>
            <hr className="shop-hr" />  
          </div>

          {error && <p className="text-danger">{error}</p>}
          {!error && complaints.length === 0 && <p>No complaints found.</p>}
          {!error && complaints.length > 0 && (
              <div className='order-list mt-5'>
                {complaints.map((complaint, index) => (
                  <div className='order-item' key={index}>
                    <h5>Ticket ID #00{complaint.ticketId}</h5>
                    <h6 className='mt-4'>Complaint Details</h6>
                    <p className='text-muted para-text'>Complaint raised on: {formatDate(complaint.query_date)}<br />
                    Order No: #00{complaint.order_id}<br/>
                    Query: {complaint.query}<br />
                    Complaint Status: {complaint.status || 'NA'}</p>
                  </div>
                ))} 
              </div>
          )}

      </div>
    </section>
    </>
  )
}

export default MyQuery
